import { net } from 'zf-web-infra';
import { BACKENDS, DOMAIN } from 'config';
import type { UserInfo } from '@features/login/types';
import type * as Types from './types';


export class RootService {

  async getUser(params: Types.UserInfoParams): Promise<UserInfo> {
    const domains = Object.entries(DOMAIN)
      .filter(([, value]) => value === params.app)
      .map(([key]) => key);

    const baseURL = domains.includes(location.hostname)
      ? location.origin : BACKENDS[params.app.toUpperCase() as keyof typeof BACKENDS];

    return await net.get('/api/account/info', params, {
      baseURL
    });
  }

}
